import { useState, useEffect } from "react";
import { useSelectorApp, useDispatchApp } from "../lib/redux";
import {
  closeCreativeNotification,
  isCreativeNotification,
} from "../actions/creativeJobs";
import { removeNotification } from "../actions/alerts";
import { ALERTS_ASYNC_STATUS } from "../utils/constants";
import { sortNotificationsByRecency } from "../utils/notifications";

/**
 * Custom hook to manage notifications state and actions
 * @returns {Object} Notifications state and handlers
 */
export const useNotifications = () => {
  const dispatch = useDispatchApp();
  const notifications = useSelectorApp(
    (state) => state.alerts?.notifications || []
  );
  const [activeAlerts, setActiveAlerts] = useState([]);

  const hasActiveProcessing = activeAlerts.some(
    (a) =>
      a?.status === ALERTS_ASYNC_STATUS.LOADING ||
      a?.status === ALERTS_ASYNC_STATUS.GENERATING
  );

  useEffect(() => {
    setActiveAlerts(sortNotificationsByRecency(notifications));
  }, [notifications]);

  const onCloseAlert = (alertId) => {
    const notification = notifications.find((alert) => alert.id === alertId);

    setActiveAlerts((previousAlerts) =>
      sortNotificationsByRecency(
        previousAlerts.filter((alert) => alert.id !== alertId)
      )
    );

    if (isCreativeNotification(notification)) {
      dispatch(closeCreativeNotification(alertId));
      return;
    }

    dispatch(removeNotification(alertId));
  };

  return {
    activeAlerts,
    hasActiveProcessing,
    onCloseAlert,
  };
};
